import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Stack } from '@mui/material';

import { Modal } from 'components/Modal';
import { FormProvider, Select, TextField } from 'components/Form';
import useYupValidationResolver from 'hook/useYupValidationResolver';

import { useCreateRole } from '../api/createRole';
import { useUpdateRole } from '../api/updateRole';
import { roleValidationSchema } from '../validation';

export const RoleFormModal = ({
  resource,
  id,
  lotId,
  role,
  structures,
  open,
  handleClose,
  onSaved,
}) => {
  const isEdit = !!role?.role_id;

  const methods = useForm({
    defaultValues: { level_structure_id: '', name: '', description: '' },
    resolver: useYupValidationResolver(roleValidationSchema),
  });

  const onSuccess = () => {
    onSaved();
    handleClose();
  };
  const { mutateAsync: createRole } = useCreateRole(resource, id, onSuccess);
  const { mutateAsync: updateRole } = useUpdateRole(resource, id, onSuccess);

  const { reset } = methods;
  useEffect(() => {
    if (open) {
      reset({
        level_structure_id:
          role?.level_structure_id ??
          (structures.length === 1 ? structures[0].level_structure_id : ''),
        name: role?.name ?? '',
        description: role?.description ?? '',
      });
    }
  }, [open, role, structures, reset]);

  const onSubmit = (values) => {
    const request = isEdit
      ? updateRole({ lotId, roleId: role.role_id, ...values })
      : createRole({ lotId, ...values });
    request.catch(() => {});
  };

  return (
    <Modal title={isEdit ? 'Edit role' : 'Add role'} open={open} handleClose={handleClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack gap={3} mb={3}>
          <TextField fullWidth name="name" label="Name" placeholder="Please enter name" required />
          <TextField
            fullWidth
            name="description"
            label="Description"
            placeholder="Please enter description"
            multiline
            minRows={3}
            sx={{ '& .MuiInputBase-root': { p: 0 } }}
          />
          <Select
            fullWidth
            name="level_structure_id"
            label="Level structure"
            placeholder="Please select level structure"
            required
            options={structures.map(({ level_structure_id, name }) => ({
              label: name,
              value: level_structure_id,
            }))}
          />
        </Stack>

        <Stack direction="row" gap={3} justifyContent="center">
          <Button variant="outlined" color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit">
            {isEdit ? 'Update' : 'Add'}
          </Button>
        </Stack>
      </FormProvider>
    </Modal>
  );
};
